import { Close } from '@carbon/icons-react';
import { SxProps } from '@mui/material';
import { Box } from '@mui/material';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import * as Preact from 'preact';
import * as MaterialContainer from './M_MaterialContainer';
import { Option } from './M_MaterialContainer';

// placeholder type
export type GlobalProperty = {
    name?: string;
    minPrice?: string;
    options: Option[];
};

export interface Props {
    open: boolean;
    loading: boolean;
    selectedGlobalOption: string | number | null;
    properties: GlobalProperty[];
    onCloseClick: () => void;
    onOptionClick: (value: string) => void;
    activeTab: string;
    tabProps?: {
        tabs: {
            id: string;
            header: string;
        }[];
        onTabClick: (id: string) => void;
    };
    drawerSx?: SxProps;
    paperSx?: SxProps;
}

export const Component = (p: Props) => {
    return (
        <Drawer
            onClose={!p.loading ? p.onCloseClick : undefined}
            anchor="left"
            open={p.open}
            sx={{
                width: { xs: `calc(100% - 36px)`, sm: '360px' },
                maxWidth: '360px',
                height: '100%',
                position: 'fixed',
                ...p.drawerSx,
            }}
            BackdropProps={{
                sx: {
                    borderRadius: { md: '24px' },
                    right: 0,
                    maxWidth: { md: 'calc(100% - 72px)' },
                    backgroundColor: 'rgba(34, 33, 76, 0.2)',
                },
            }}
            PaperProps={{
                sx: {
                    width: { xs: '100%', sm: '360px' },
                    position: 'absolute',
                    paddingY: '12px',
                    border: 'none',
                    gap: p.tabProps ? 0 : '12px',
                    boxSizing: 'border-box',
                    ...p.paperSx,
                },
            }}
            variant="temporary"
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    height: '44px',
                    padding: '8px 19px',
                    boxSizing: 'border-box',
                }}
            >
                <IconButton
                    onClick={p.onCloseClick}
                    disabled={p.loading}
                    sx={{ height: '28px', width: '28px', padding: '4px' }}
                >
                    <Close size={20} />
                </IconButton>
            </Box>
            {p.tabProps && (
                <Tabs
                    value={p.activeTab}
                    sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        backgroundColor: '#FFFFFF',
                    }}
                    variant="fullWidth"
                >
                    {p.tabProps.tabs.map((tab, i) => {
                        return (
                            <Tab
                                label={tab.header}
                                value={tab.id}
                                disabled={p.loading && p.activeTab !== tab.id}
                                sx={{
                                    color: 'text.secondary',
                                    fontSize: '14px',
                                    textTransform: 'capitalize',
                                }}
                                onClick={() => p.tabProps?.onTabClick(tab.id)}
                            />
                        );
                    })}
                </Tabs>
            )}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '24px',
                    gap: '12px',
                    overflowY: 'auto',
                    width: '100%',
                    boxSizing: 'border-box',
                }}
            >
                {p.properties &&
                    p.properties.map((m: GlobalProperty) => {
                        return (
                            <>
                                <MaterialContainer.Component
                                    name={m.name}
                                    loading={p.loading}
                                    selectedGlobalOption={p.selectedGlobalOption}
                                    minPrice={m.minPrice}
                                    options={m.options}
                                    onMaterialClick={p.onOptionClick}
                                />
                                <Divider />
                            </>
                        );
                    })}
            </Box>
        </Drawer>
    );
};

Component.displayName = 'MaterialMenu';
